import { render, staticRenderFns } from "./ChoiceField.vue?vue&type=template&id=7bb245b0&"
import script from "./ChoiceField.vue?vue&type=script&lang=js&"
export * from "./ChoiceField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports